<!-- ImageIcon.vue -->
<script lang="ts" setup>
    import { computed } from 'vue';
    import { ImageType, choiceImageTypeUrls } from '../../lib/OfficeMd/images';

    const props = defineProps<{
        image: ImageType,
        title?: string,
        class?: string,
        performAction?: () => Promise<void>    // Async action to perform
    }>();

    async function onClick()
    {
        if (!props.performAction)
            return;
        await props.performAction();
    }

    const imgStyle = computed<string|undefined>(()=>{
        if (!props.performAction)
            return "cursor:default";
    });
</script>
<template>
    <img 
        :src="choiceImageTypeUrls[props.image]" 
        :tabindex="props.title" 
        :alt="props.title"
        :style="imgStyle"
        :class="props.class"
        @click="onClick" />
</template>